export const FINANCIAL_GROUPINGSEPARATOR_OPTION_COMMA = 44
export const FINANCIAL_GROUPINGSEPARATOR_OPTION_FULL_STOP = 46
export const FINANCIAL_GROUPINGSEPARATOR_OPTION_SPACE = 32

export const FINANCIAL_DECIMAL_SEPARATOR_OPTION_FULL_STOP = 46
export const FINANCIAL_DECIMAL_SEPARATOR_OPTION_COMMA = 44
export const FINANCIAL_DECIMAL_SEPARATOR_OPTION_COLON = 58
